import React, { FC } from 'react'

import { Page, PageContent } from 'common'
import { InterSvgIcon, Header } from 'components'

import { Text } from '@interco/inter-ui/components/Text'

import { ErrorMessageContainer } from './styles'

export type NoResultsFoundProps = {
  icon: string
  title: string
  details: string
}

export const NoResultsFound: FC<NoResultsFoundProps> = ({ icon, title, details }) => (
  <Page>
    <Header title="" />
    <PageContent>
      <ErrorMessageContainer>
        <InterSvgIcon iconRef={icon} height={64} width={64} color="var(--error500)" />
        <Text variant="headline-h1" color="typography" colorWeight={500} bold>
          {title}
        </Text>
        <Text variant="body-3" color="typography">
          {details}
        </Text>
      </ErrorMessageContainer>
    </PageContent>
  </Page>
)
